angular.
module("dx.webapp.examParts").
controller("DxExamPartsController", function examPartsController(
	DX_EXAM_PARTS,
	DX_GRADING_TYPES,

	dxBitFlagsHelper,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_EXAM_PARTS = DX_EXAM_PARTS;
	self.DX_GRADING_TYPES = DX_GRADING_TYPES;
	self.isBitIncluded = dxBitFlagsHelper.isBitIncluded;
	self.anyOptionEnabled = function anyOptionEnabled(enabledOptions, mask) {
		return (enabledOptions & mask) > 0;
	};

	self.helpUrl = dxLocalize.getLanguage() === "sv" ?
		"https://support.digiexam.se/hc/sv/articles/360020163493" :
		"https://support.digiexam.se/hc/en-us/articles/360020163493";

	if (typeof self.availableOptions === "undefined") {
		self.availableOptions = DX_EXAM_PARTS.ALL_PARTS;
	}

	self.isItemSelected = function isItemSelected(bit) {
		return (self.selection & bit) > 0;
	};

	self.areAllItemsSelected = function areAllItemsSelected() {
		return self.selection === self.availableOptions;
	};

	self.toggleSelected = function toggleSelected(bit) {
		var isSelected = self.isItemSelected(bit);

		if (bit === DX_EXAM_PARTS.QUESTION_ALTERNATIVE && isSelected &&
			self.isItemSelected(DX_EXAM_PARTS.QUESTION_ALTERNATIVE_CORRECT)) {
			bit += DX_EXAM_PARTS.QUESTION_ALTERNATIVE_CORRECT; // eslint-disable-line no-param-reassign
		}

		if (bit === DX_EXAM_PARTS.ANSWER_DATA &&
			self.isItemSelected(DX_EXAM_PARTS.ANSWER_WORD_COUNT)) {
			bit += DX_EXAM_PARTS.ANSWER_WORD_COUNT; // eslint-disable-line no-param-reassign
		}

		self.selection += isSelected ? -bit : bit;
	};

	self.toggleAll = function toggleAll() {
		self.selection = self.areAllItemsSelected() ? DX_EXAM_PARTS.NONE : self.availableOptions;
	};
});
